import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PrescriptionMedicineCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine-check.struct';
import { PrescriptionSolutionCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-check.struct';

@Component({
    selector: 'app-prescricption-check-history-modal',
    templateUrl: './prescricption-check-history-modal.component.html',
    styleUrls: ['./prescricption-check-history-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescricptionCheckHistoryModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescricptionCheckHistoryModalComponent>,
  ) { }

  public listPrescriptionMedicineCheckStruct: PrescriptionMedicineCheckStruct[] = [];
  public listPrescriptionSolutionCheckStruct: PrescriptionSolutionCheckStruct[] = [];

  public isMedicatedSolution: boolean = false;

  ngOnInit(): void {
    this.isMedicatedSolution = this.data.isMedicatedSolution;
    if(this.isMedicatedSolution)
      this.listPrescriptionSolutionCheckStruct = this.data.listPrescriptionCheck;
    else
      this.listPrescriptionMedicineCheckStruct = this.data.listPrescriptionCheck;
  }

  close() {
    this.matDialogRef.close();
  }
}
